import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface MobileAssetDrawerProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

const MobileAssetDrawer: React.FC<MobileAssetDrawerProps> = ({ open, title, onClose, children }) => {
  const [visible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);
  const backdropRef = useRef<HTMLDivElement>(null);
  const prevOverflowRef = useRef('');

  useEffect(() => {
    if (open) {
      setVisible(true);
      requestAnimationFrame(() => setAnimating(true));
      prevOverflowRef.current = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    } else if (visible) {
      setAnimating(false);
      const saved = prevOverflowRef.current;
      const timer = setTimeout(() => {
        setVisible(false);
        document.body.style.overflow = saved;
      }, 300);
      return () => clearTimeout(timer);
    }
    return () => {
      document.body.style.overflow = prevOverflowRef.current;
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div
      ref={backdropRef}
      className={`mobile-drawer-backdrop ${animating ? 'open' : ''}`}
      onClick={(e) => { if (e.target === backdropRef.current) onClose(); }}
    >
      <div className={`mobile-drawer-panel ${animating ? 'open' : ''}`}>
        {/* Header */}
        <div className="mobile-drawer-header">
          <button className="mobile-drawer-back" onClick={onClose}>
            <span>&lsaquo;</span>
          </button>
          <h3 className="mobile-drawer-title">{title}</h3>
          <div style={{ width: 40 }} /> {/* spacer for centering */}
        </div>

        {/* Content */}
        <div className="mobile-drawer-content">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MobileAssetDrawer;
